import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Dispara um evento `page_view` no Google Analytics (GA4)
 * a cada mudança de rota dentro da SPA.
 */
const GA_ID = 'G-6QP9GPHKFB';

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', GA_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

export default GoogleAnalytics;
